import React from 'react';

import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import Box from '@mui/material/Box';

import withReadModeField from 'components/shared/CRUD/components/InnerPage/components/withReadModeField';
import { ControlledTextField } from 'components/shared/ControlledFields';

import WithEditPageLayout, {
  WithEditPageLayoutProps
} from '../../WithEditPageLayout';

const NameField = withReadModeField(ControlledTextField);

const GeneralFormFields: React.FC<WithEditPageLayoutProps> = () => {
  const { t } = useTranslation('common');
  const { control } = useFormContext();

  return (
    <Box maxWidth={400} mb={4}>
      <NameField control={control} name="name" label={t('name')} />
    </Box>
  );
};

export default WithEditPageLayout(GeneralFormFields);
